import React from 'react';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Services from './components/Services';
import Contact from './components/Contact';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-white min-h-screen">
        <Navbar />
        <Hero />
        <About />
        <Projects />
        <Services />
        <Contact />
        <CookieConsent />
      </div>
    </LanguageProvider>
  );
}

export default App;